/*
 * Copyright (C) 2019 - present by Potentially
 *
 * Please see distribution for license.
 */

import { LikesDetails } from '@app/app/shared/models/comment/comment.model';
import { EditorContent, ResourceTag } from '../../../shared/models';

export enum MomentVisibility {
  Public = 'public',
  Private = 'private',
}

/** Defines the author summary attached to a moment. */
export interface MomentAuthor {
  fullName: string;
  avatarUrl: string;
  role: string;
}

/** Defines a moment. */
export interface Moment {
  /** The moment unique ID. */
  _id?: string;
  /** The moment title. */
  title: string;
  /** The uid of the user who created the moment. */
  userUid?: string;
  /** The moment author. */
  author?: MomentAuthor;
  /** The likes information for the moment. */
  likes: LikesDetails;
  commentsCount: number;
  /** The number of views the moment has. */
  totalViews?: number;
  /** The number of shares the moment has. */
  /** The tags associated with the moment. */
  tags: ResourceTag[];
  /** The dynamic content. */
  content: EditorContent[];
  /** The date the moment was created. */
  createdAt?: Date;
  /** Defines if the moment has been added to user's folio. */
  addedToFolio: boolean;
  /** Defines the visibility of the moment: 'public' or 'private'. */
  visibility?: MomentVisibility;
  /** Defines if the moment item is visible. */
  visible?: boolean;
  /** True when the current user has saved/bookmarked this moment. */
  saved?: boolean;
  /** The uid of the learning experience (Evidence entry) this moment mirrors, or null for a standalone post. */
  linkedLearningExperienceUid?: string | null;
  /** The uid of the playlist (e.g. program) this moment is scoped to, or undefined for the organization-wide community. */
  playlistUid?: string;
  /** The name of the playlist this moment is scoped to, used for attribution in the organization-wide community feed. */
  playlistName?: string;
}
